import {Routes} from '@angular/router';
import {CvDownloadPageComponent} from './cv-download-page.component';

/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
const routes: Routes = [{path: 'download', component: CvDownloadPageComponent}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/cv-download-page.routing.ts